import { render } from "./ItemsMaster.vue?vue&type=template&id=dc21faf4&scoped=true"
import script from "./ItemsMaster.vue?vue&type=script&lang=js"
export * from "./ItemsMaster.vue?vue&type=script&lang=js"

import "./ItemsMaster.vue?vue&type=style&index=0&id=dc21faf4&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc21faf4"]])

export default __exports__